<template>
	<div id="subscriptionChurch" class="subscriptionChurch">
		<table class="table-local table-bordered">
			<thead>
				<tr>
					<th class="text-center align-middle">Cliente</th>
					<th class="text-vertical-lr align-top" v-for="(item, index) in listProduct" :key="index" :title="item.name + '(' + item.id + ')'">{{ item.synthetic }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listClient" :key="index">
					<td :title="item.id" class="pointe" @click="clientId = item.id">{{item.name}}</td>
					<td class="text-right td" v-for="(it, ind) in listProduct" :key="ind" @mouseover="marcar($event)">{{ quantityProductClient(it.id, item.id) }}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th class="text-right">TOTAL</th>
					<th class="text-right" v-for="(item, index) in listProduct" :key="index">{{ quantityProduct(item.id) }}</th>
				</tr>
			</tfoot>
		</table>
		<hr>
		<table class="table table-sm table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Cliente</th>
					<th class="text-center">Estado</th>
					<th class="text-center">Fecha</th>
					<th class="text-center">Total</th>
					<th class="text-center">Pagado</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listOrdersChurch" :key="index" :class="(item.client_id == clientId) ? 'font-weight-bold': ''">
					<td class="text-center">{{ item.id }}</td>
					<td class="text" :title="item.client_id">{{ item.client.name }} {{ item.client.surname }}</td>
					<td class="text-center">{{ item.status.name }}</td>
					<td class="text-center">{{ item.created_at }}</td>
					<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
					<td class="text-center">
						<i class="fas fa-check text-success" v-if="item.paid == 1"></i>
						<i class="fas fa-minus text-black-50" v-else></i>
					</td>
					<td class="text-right">
						<router-link :to="'/subscription/' + item.id" target="_blank" class="pointer far fa-eye text-info" title="Ver detalle"></router-link>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import church from '@/mixins/generals/church.js'

import Pagination from '@/components/Pagination.vue'
export default {
	name: 'SubscriptionChurch',
	mixins: [axiosAction, errors, mixin, church],
	props: ['year', 'id'],
	data() {
		return {
			onlyPaid: 1,
			listOrdersChurch: [],
			listOrderProductChurch: [],
			clientId: 0
		}
	},
	computed: {
		url() {
			return this.apiBackend + 'statistic/subscription/'
		},
		listProduct() {
			let list = []
			for (const [key, value] of Object.entries(this.listOrderProductChurch)) {
				let index = list.map((el) => parseInt(el.id)).indexOf(parseInt(value.id))
				if(index == -1) {
					list.push({id: value.id, name: value.name, synthetic: value.synthetic})
				}
			}
			return list
		},
		listClient() {
			let list = []
			for (const [key, value] of Object.entries(this.listOrderProductChurch)) {
				let index = list.map((el) => parseInt(el.id)).indexOf(parseInt(value.client_id))
				if(index == -1) {
					list.push({id: value.client_id, name: value.client_name + ' ' + value.surname})
				}
			}
			return list
		},
		listProductClient() {
			let list = []
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Estadisticas ' + this.id)
			this.setSubTitleModule(' año ' + this.year + '')
			this.showChurchLocal()
		},
		getOrderChurchLocal() {
			let param = '?paid=' + this.onlyPaid
			let url = this.url + this.year + '/church/' + this.id + param
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getOrderChurchLocalResult')
		},
		getOrderChurchLocalResult(response) {
			if(response.data.success === true) {
				this.listOrdersChurch = response.data.data.orders
				this.listOrderProductChurch = response.data.data.products
			} 
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getOrderChurchLocalResult': this.getOrderChurchLocalResult(response); break;
				case 'showChurchResult': this.showChurchResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		showChurchLocal() {
			this.clientId = 0
			this.showChurch(this.id)
		},
		showChurchResultLocal(response) {
			if(this.objectChurch.id > 0) {
				this.setTitleModule('Estaditicas ' + this.objectChurch.type_church.name + ' ' + this.objectChurch.name)
				this.getOrderChurchLocal()
			}
		},
		quantityProduct(id) {
			let sum = 0
			for (const [key, value] of Object.entries(this.listOrderProductChurch)) {
				if(value.id == id)
					sum+= parseInt(value.quantity)
			}
			return sum
		},
		quantityProductClient(id, client_id) {
			let sum = 0
			for (const [key, value] of Object.entries(this.listOrderProductChurch)) {
				if(value.id == id && value.client_id == client_id) {
					sum+= parseInt(value.quantity)
				}
			}
			return (sum == 0) ? '' : sum
		},
		marcar(event) {
			console.log(event);
		}
	},
	components: {
		'pagination': Pagination,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
.table-local {
	display:inline-block;
	overflow: hidden;
	width: 100%;
	td, th {
		position: relative;
	}

	td:hover::before, th:hover::before{
		content: "";
		position: absolute;
		background-color: #ffa;
		left: 0;
		top: -5000px;
		height: 10000px;
		width: 100%;
		z-index: -1;
	}

	
	td:hover::before, td:hover::before{
		content: "";
		position: absolute;
		background-color: #ffa;
		left: 0;
		top: -5000px;
		height: 10000px;
		width: 100%;
		z-index: -1;
	}
}
</style>